import { Link } from './link-type';

export interface MediaLink {
  linkType: Link;
  url: string;
  name: string;
}
